import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_74: FaireProductEntity = {
  token: "legacy_prod_abbott-74",
  type: "product",
  name: "Multi Dogs Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7322f693ce15a7dec080ff40a0423b5a728f1955cc5c2754759559edbf68599b.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
